var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlipCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 37L9.59141 26.0541L4.81632 39.6752L19 37ZM19 4.25C19.6904 4.25 20.25 3.69036 20.25 3C20.25 2.30964 19.6904 1.75 19 1.75V4.25ZM9.16466 32.3024C5.55693 29.4141 3.25 24.9769 3.25 20H0.75C0.75 25.7681 3.42735 30.9116 7.60222 34.254L9.16466 32.3024ZM3.25 20C3.25 11.3015 10.3015 4.25 19 4.25V1.75C8.9208 1.75 0.75 9.9208 0.75 20H3.25Z",
    fill: "#F8BA34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 38.25C22.3096 38.25 21.75 37.6904 21.75 37C21.75 36.3096 22.3096 35.75 23 35.75V38.25ZM23 3L37.1837 0.324844L32.4086 13.9459L23 3ZM23 35.75C31.6985 35.75 38.75 28.6985 38.75 20H41.25C41.25 30.0792 33.0792 38.25 23 38.25V35.75ZM38.75 20C38.75 15.0231 36.4431 10.5859 32.8353 7.69763L34.3978 5.74602C38.5727 9.08838 41.25 14.2319 41.25 20H38.75Z",
    fill: "#F8BA34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipCamera);
export default __webpack_public_path__ + "static/media/flipCamera.7aa758af47e76f181620e1767db2b397.svg";
export { ForwardRef as ReactComponent };